import { groupBy, map, keys, uniq, sortWith, ascend, prop } from 'ramda'
import chunk from 'chunk'

import { genLabel, labelHeader } from './label_flash'
import { MAX_ITEMS } from '../constants'

export const groupData = ({ rows, group, max = MAX_ITEMS }) => {
  const expandData = rows
    .map(row => Array(parseInt(row.Quantity, 10)).fill({ ...row, Quantity: 1 }))
    .reduce((a, b) => a.concat(b), [])
  const byOrder = groupBy(row => row.Order)
  const orders = byOrder(expandData)
  const groupItems = (items) => {
    const groupedItems = groupBy(item => item.Name, items)
    const countedItems = map(g => g.reduce((prev, item) => prev + item.Quantity, 0), groupedItems)
    return keys(countedItems).map(name => ({ name, amount: countedItems[name], sku: groupedItems[name][0].sku }))
  }
  const sortItems = items => sortWith([ascend(prop('name'))])(items)
  const data = []
  Object.keys(orders).map(orderId => orders[orderId]).forEach((order) => {
    const packs = chunk(order, max)
    packs.forEach((items, index) => {
      const first = items[0]
      const mappedItems = groupItems(items)
      data.push({
        app: 'shop',
        referenceId: first.Order,
        recipient: first['ชื่อผู้รับ'].replace(/\s{1,}/g, ' ').replace(/\u200B/g, ''),
        address: `${first['ที่อยู่']} ${first['จังหวัด']} ${first.Zip}`.replace(/\s{1,}/g, ' ').replace(/\u200B/g, ''),
        data: {
          zipcode: first.Zip,
          count: items.length,
          items: sortItems(mappedItems),
          phones: [first['Phone (Billing)']],
        },
        seq: index + 1,
        last: packs.length,
        group,
        remarks: '',
      })
    })
  })
  return data
}
export const createLabel = (label, labelQrcode) => `
<td class="main-cell">
  <div class="label">
    ${labelQrcode(label)}
    <div class="recipient">
      <div class="recipient-data">
      [${label.referenceId}] ${label.recipient} (${uniq(label.data.phones).join(', ')})<br />
      ${label.address}
      </div>
    </div>
    <div class="items">
      <div class="items-data">
        ${label.data.items.map(d => `[ ${d.amount} ] ${d.name}`).join('<br />')}
      </div>
    </div>
    ${labelHeader}

  </div>
</td>`

export default {
  groupData,
  genLabel: genLabel(createLabel),
}



// WEBPACK FOOTER //
// ./src/helpers/shop_flash.js